import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React, { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { useSaleControllerProvider } from "../../../../utils/sale-controller";
import { QuickKey } from "../../../QuickKey";

export const CustomerAccountPaymentQuickKey = React.forwardRef<any, unknown>(
  (props, ref) => {
    const { sale } = useSaleControllerProvider();
    const { colors: Colors } = useTheme();
    const navigation = useNavigation<SellScreenProps["navigation"]>();

    const disabled = !sale;

    const onPress = useCallback(() => {
      if (disabled) return;
    }, [disabled]);

    return (
      <QuickKey
        label="Customer Account Payment"
        {...{ ref, disabled, onPress }}
        iconPrimary={
          <MaterialIcons
            name="payment"
            size={24}
            color={disabled ? Colors.text : Colors.quickKeyActionText}
          />
        }
        backgroundColor={Colors.action}
        isAction={true}
        disabled={true}
      />
    );
  }
);
